import { useFormikContext } from 'formik';
import React, { memo, useEffect, useState } from 'react';

import { ProgressBar } from '~/components/ProgressBar';
import { CreateCompanyFormValues } from '~/types/formValues';
import { calculateCompanyFilledPercent } from '~/utils/calculations';

import styles from './styles.module.scss';

const Component: React.FC = () => {
  const [profileCompletedPercentage, setProfileCompletedPercentage] = useState(0);
  const formik = useFormikContext<CreateCompanyFormValues>();

  useEffect(() => {
    setProfileCompletedPercentage(calculateCompanyFilledPercent(formik.values.form));
  }, [formik.values.form]);

  return (
    <ProgressBar
      className={styles['progress-bar']}
      label="Profile completed"
      value={profileCompletedPercentage}
    />
  );
};

export const ProgressBarContainer = memo(Component);
